import { render, staticRenderFns } from "./ServiceIntro.vue?vue&type=template&id=1fc58b24&"
import script from "./ServiceIntro.vue?vue&type=script&lang=js&"
export * from "./ServiceIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports